import { profileContactInfoPages } from 'platform/forms-system/src/js/patterns/prefill';
import { getContent } from 'platform/forms-system/src/js/utilities/data/profile';

const contactInfoContent = {
  ...getContent('application'),
  description: null,
  email: 'Current email',
  editEmail: 'Edit email',
  addEmail: 'Add email',
  homePhone: 'Preferred phone number',
  editHomePhone: 'Edit phone number',
  addHomePhone: 'Add phone number',
  missingHomePhone: 'phone number',
};

export default profileContactInfoPages({
  content: contactInfoContent,
  contactInfoPageKey: 'contactInformation',
  contactPath: 'claimant/contact-information',
  wrapperKey: 'contactInformation',
  homePhoneKey: 'claimantPhone',
  emailKey: 'email',
  included: ['email', 'claimantPhone'],
  contactInfoRequiredKeys: ['email'],
  prefillPatternEnabled: true,
  showProfileAlert: true,
});
